import trainingListStore from '@modules/training/training-list-store';
import trainingViewStore from '@modules/training/training-view-store';
import trainingImporterStore from '@modules/training/training-importer-store';
import trainingFormStore from '@modules/training/training-form-store';
import trainingDestroyStore from '@modules/training/training-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: trainingDestroyStore,
    form: trainingFormStore,
    list: trainingListStore,
    view: trainingViewStore,
    importer: trainingImporterStore,
  },
};
